<template>
  <div class="w-full h-full p-8 overflow-hidden box-border">
    <div
      class="bg-teal-600 w-full h-full rounded-lg shadow overflow-hidden"
      ref="map"
    ></div>
  </div>
</template>

<script>
import init from "@/gmaps";

export default {
  data() {
    return {
      drivers: [],
      google: null,
      markers: {},
      infowindows: {},
      map: null,
      interval: null
    };
  },
  async mounted() {
    this.google = await init();

    this.map = new this.google.maps.Map(this.$refs.map, {
      center: {
        lat: 9.004912,
        lng: 38.778282
      },
      zoom: 13
    });
  },
  created() {
    this.getDrivers();
    this.interval = setInterval(() => {
      this.getDrivers();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    delay(delayInms) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(2);
        }, delayInms);
      });
    },
    async getDrivers() {
      console.log("refreshed");
      this.$http
        .get("/godview")
        .then(response => {
          this.drivers = response.data;
          console.log("godview", this.drivers);
          this.addMarkers(this.drivers);
        })
        .catch(err => console.log(err));
    },
    addMarkers(data) {
      data.forEach(element => {
        if (element.position) {
          if (this.markers[element._id]) {
            this.markers[element._id].setMap(null);
          }
          var icon =
            "https://res.cloudinary.com/torpa/image/upload/e_tint:100:red/w_60,h_60/v1598171147/carMarker_vpibvl.png";
          if (element.online === true) {
            icon =
              "https://res.cloudinary.com/torpa/image/upload/e_tint:100:green/w_60,h_60/v1598171147/carMarker_vpibvl.png";
          }

          this.markers[element._id] = new this.google.maps.Marker({
            position: {
              lat: element.position.coordinates[1],
              lng: element.position.coordinates[0]
            },
            icon,
            title: element.driver
              ? element.driver.firstName + " " + element.driver.lastName
              : "-"
          });

          const infowindow = new this.google.maps.InfoWindow({
            content: "<p>Full Name: " +
                element.driver.firstName +
                " " +
                element.driver.lastName +
                "</p>" +
                "<p>Vehicle ID: " +
                element._id +
                "</p>" +
                "<p>Vehicle Model: " +
                element.modelName +
                "</p>" +
                "<p>Color: " +
                element.color +
                "</p>" +
                "<p>Approved: " +
                element.driver.approved +
                "</p>" +
                "<p>Rating: " +
                element.driver.rating +
                "</p>" +
                '<a href="/drivers/' +
                element.driver._id +
                '" target="_balnk" style="color:green; font-size:20px;" >locate driver</a>'
          });
          this.markers[element._id].setMap(this.map);

          this.markers[element._id].addListener("click", () => {
            infowindow.open(this.map, this.markers[element._id]);
          });
        }
      });
    }
  }
};
</script>
